export default __webpack_public_path__ + "static/media/telhado_verde_content.f895fd52.jpg";